// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"413":"container","709":"calendar","791":"video"}[chunkId] || chunkId) + "." + {"83":"fa89634a","236":"295169eb","413":"18c1fe2a","709":"9ea643cc","791":"18c1fe2a"}[chunkId] + ".chunk.css";
};